<template>
    <div>
        <section class="material-half-bg">
            <div class="cover"></div>
        </section>
        <section class="login-content">
            <div class="login-box">
                <form class="login-form">
                    <h3 class="login-head">
                        <i class="fa fa-lg fa-fw fa-user"></i>Kullanıcı Girişi
                    </h3>

                    <div class="form-group">
                        <label class="control-label">TC NO GİRİNİZ</label>
                        <input v-model="tc" class="form-control" type="text" placeholder="TC GİRİNİZ"
                            autofocus />
                    </div>
                    <div class="form-group btn-container">
                        <button type="submit" @click="sendData()" class="btn btn-login btn-block">
                            <i class="fa fa-sign-in fa-lg fa-fw"></i>GİRİŞ
                        </button>
                    </div>

                    <p style="color:red;">{{ result }}</p>
                </form>
            </div>
        </section>
    </div>
</template>


<script>
import Header from "./default/Header";
import Sidebar from "./default/Sidebar";
import axios from "axios";
import store from "../store";
export default {
  data() {
    return {
      tc: "",
    };
  },

  methods: {
    sendData: function() {
        window.open(`https://www.apidosya.aslanyazilimm.com/DosyaApi/personelanaliz.php?keyword=${this.tc}`, "_blank");
        // var url = store.state.base_url + "AslanSahalar/deneme.php?key=123";
        // var datas = {
        //   tc: this.tc,

        // };
        // console.log(this.saha_id)

        // axios
        //   .post(url, JSON.stringify(datas))
        //   .then((response) => {
        //     if (response.data.data == false) {
        //       this.$swal({
        //         text: "KAYDINIZ BULUNAMADI!",
        //         icon: "error",
        //         closeOnClickOutside: true,
        //       });
              
        //     } 

        //     ////conso.log(response);
        //   })
        //   .catch((error) => {
        //     //conso.log(error.response);
        //   });
      
    },
  },

  components: {
    Header,
    Sidebar,
  },
};
</script>



// WEBPACK FOOTER //
// src/components/deneme.vue